<template>
    <div @keydown.enter="validateAndRegister" class="tw:space-y-5">
        <div :class="{'tw:rounded-md tw:border tw:border-blue-200 tw:bg-blue-50 tw:p-4 tw:text-sm tw:text-slate-600': wizardStore.tw, 'alert alert-info': !wizardStore.tw}">
            <p class="mb-0 tw:mb-0">{{ $t('Skal du registrere flere deltakere?') }}</p>
            <p class="mb-0 tw:mb-0">
                <small>
                    {{ $t('Hvis du ikke skal legge til flere elever kan du navigere videre.') }}
                </small>
            </p>
            <p class="mb-0 tw:mb-0" v-if="wizardStore.isContact">
                <small>
                    {{ $t('Ved å fortsette blir du opprettet som kontaktperson til eleven du registrerer her.') }}
                </small>
            </p>
        </div>

        <div>
            <div v-if="wizardStore.tw" class="tw:text-xs tw:text-zinc-500">
                {{ $t("Felter markert med stjerne (*) er obligatoriske.") }}
            </div>
            <small v-if="!wizardStore.tw">
                {{ $t("Felter markert med stjerne (*) er obligatoriske.") }}
            </small>
        </div>

        <FormTextInput
            :tw="wizardStore.tw"
            :label="$t('Elevens mobilnummer') + '*'"
            :name="'mobile'"
            :type="'tel'"
            :placeholder="$t('Elevens mobilnummer')"
            :maxlength="10"
            :disabled="wizardStore.isLoadingAdditionalStudent"
            v-model="wizardStore.additionalStudent.mobile"
            :error="wizardStore.additionalStudent.errors.mobile"
        />

        <FormTextInput
            :tw="wizardStore.tw"
            :label="wizardStore.getStudentFnrLabel + '*'"
            :name="'fnr'"
            :type="'tel'"
            :placeholder="wizardStore.getStudentFnrLabel"
            :disabled="wizardStore.isLoadingAdditionalStudent"
            v-model="wizardStore.additionalStudent.fnr"
            :error="wizardStore.additionalStudent.errors.fnr"
        />

        <div v-if="wizardStore.showAdditionalStudentDetailFields">
            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Fornavn') + '*'"
                :name="'first_name'"
                :placeholder="$t('Fornavn')"
                :disabled="!!(wizardStore.additionalStudent.lookupResponse && wizardStore.additionalStudent.lookupResponse.first_name)"
                v-model="wizardStore.additionalStudent.firstName"
                :error="wizardStore.additionalStudent.errors.firstName"
            />

            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Etternavn') + '*'"
                :name="'last_name'"
                :placeholder="$t('Etternavn')"
                :disabled="!!(wizardStore.additionalStudent.lookupResponse && wizardStore.additionalStudent.lookupResponse.last_name)"
                v-model="wizardStore.additionalStudent.lastName"
                :error="wizardStore.additionalStudent.errors.lastName"
            />


            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Adresse') + '*'"
                :name="'address'"
                :placeholder="$t('Adresse')"
                :disabled="!!(wizardStore.additionalStudent.lookupResponse && wizardStore.additionalStudent.lookupResponse.address)"
                v-model="wizardStore.additionalStudent.address"
                :error="wizardStore.additionalStudent.errors.address"
            />

            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Postnummer') + '*'"
                :name="'postalCode'"
                :placeholder="$t('Postnummer')"
                :disabled="!!(wizardStore.additionalStudent.lookupResponse && wizardStore.additionalStudent.lookupResponse.postal_code)"
                v-model="wizardStore.additionalStudent.postalCode"
                :error="wizardStore.additionalStudent.errors.postalCode"
            />

            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Sted') + '*'"
                :name="'city'"
                :placeholder="$t('Sted')"
                :disabled="!!(wizardStore.additionalStudent.lookupResponse && wizardStore.additionalStudent.lookupResponse.city)"
                v-model="wizardStore.additionalStudent.city"
                :error="wizardStore.additionalStudent.errors.city"
            />
            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('E-postadresse') + '*'"
                :name="'email'"
                :placeholder="$t('E-postadresse')"
                :disabled="!!(wizardStore.additionalStudent.lookupResponse && wizardStore.additionalStudent.lookupResponse.email)"
                v-model="wizardStore.additionalStudent.email"
                :error="wizardStore.additionalStudent.errors.email"
            />

            <div class="form-group" v-if="wizardStore.hasResourcePool">
                <label class="mt-1">{{ $t('Valg av kjøretøy') }}*</label>
                <select name="resource-class-id" v-model="wizardStore.additionalStudent.resourcePoolClassId"
                        class="form-select input-lg">
                    <option value="0" disabled selected>- {{ $t("Velg") }} -</option>
                    <option :value="pool.class_id" :disabled="pool.free_slots <= wizardStore.getResourcePoolClassIdsArray.filter(id => id === pool.class_id).length"
                            v-for="pool in wizardStore.availableResourcePools">
                        {{ pool.classes_meta.resource_pool_class_name_on_web || pool.class_name }}
                        <span v-if="pool.free_slots <= wizardStore.getResourcePoolClassIdsArray.filter(id => id === pool.class_id).length">({{ $t("Ingen flere ledige plasser") }})</span>
                    </option>
                </select>
            </div>

            <div class="form-check my-2" v-if="wizardStore.freeInterpreterSlots > 0">
                <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" value="1" name="with-interpreter" :disabled="!wizardStore.hasFreeInterpreterSlots && !wizardStore.additionalStudent.withInterpreter"
                           v-model="wizardStore.additionalStudent.withInterpreter">
                    {{ $t("Med tolk") }}
                </label>
            </div>
        </div>

        <div :class="{'btn btn-link': !wizardStore.tw, 'tw:text-sm tw:text-(--shop-primary) tw:underline tw:cursor-pointer': wizardStore.tw}" @click="wizardStore.toggleManuallyRegisterAdditionalStudent" v-if="noAdditionalStudentLookupResponse">
            {{ wizardStore.toggleManuallyRegisteredStudentLabel }}
        </div>
        <loadingSpinner :isLoading="wizardStore.isLoadingAdditionalStudent"></loadingSpinner>

        <div v-if="wizardStore.student.errors.lookup" class="alert alert-danger">
            {{ wizardStore.student.errors.lookup }}
        </div>


        <div :class="{'d-flex my-2 justify-content-between': !wizardStore.tw, 'tw:md-flex tw:block tw:justify-between my-2': wizardStore.tw}">

            <PrimaryButton
                :tailwind="wizardStore.tw"
                :disabled="wizardStore.isRegistering || wizardStore.isLoadingAdditionalStudent"
                :onClick="validateAndRegister"
                :label="registerMoreLabel"
            />
            <PrimaryButton
                :tailwind="wizardStore.tw"
                :disabled="wizardStore.isRegistering || wizardStore.isLoadingAdditionalStudent"
                :onClick="continueAndAddIfInfoIsFilled"
                :label="$t('Gå videre')"
            />
        </div>

        <loadingSpinner :isLoading="wizardStore.isRegistering" :tw="wizardStore.tw"></loadingSpinner>

        <div v-if="wizardStore.registerError" class="alert alert-danger">
            {{ wizardStore.registerError }}
        </div>

        <div v-if="wizardStore.additionalAttendees.length > 0" :class="{'border rounded-2 p-2 mt-3': !wizardStore.tw}">
            <p class="mb-1 tw:block tw:text-sm tw:font-medium tw:text-zinc-800">{{ $t('Ekstra deltakere:') }}</p>
            <ul v-for="(student, i) in wizardStore.additionalAttendees"
                :key="i" class="mb-0 tw:mb-0 tw:list-none tw:border tw:border-zinc-200 tw:rounded-lg tw:space-y-1 tw:mb-1">
                <li class="mb-1 tw:px-1 tw:py-2 tw:text-sm">{{ student.firstName }} {{ student.lastName }}
                    <span :class="{
                        'btn btn-danger btn-sm ms-1': !wizardStore.tw,
                        'tw:text-xs tw:ml-4 tw:bg-(--shop-primary) tw:inline-block tw:rounded-0 tw:px-2 tw:py-1 tw:cursor-pointer tw:rounded-4xl tw:text-white': wizardStore.tw
                    }" @click="removeAttender(i)"><i class="fa fa-trash-o"></i> {{ $t('Slett')}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
    import { STEP_ADDITIONAL_ATTENDEES, useWizardStore } from './wizardState';
    import loadingSpinner from "./loadingSpinner.vue";
    import { computed, watch } from "vue";
    import FormTextInput from "./FormTextInput.vue";
    import PrimaryButton from './primaryButton.vue'

    // Use the centralized wizard store
    const wizardStore = useWizardStore();

    watch(() => wizardStore.additionalStudent.fnr, () => {
        if (wizardStore.additionalStudent.errors && wizardStore.additionalStudent.errors.lookup) {
            delete wizardStore.additionalStudent.errors.lookup;
        }
        if (!wizardStore.additionalStudentHasValidFnrAndMobile()) {
            wizardStore.disableManuallyRegisterAdditionalStudent()
            return;
        }
        wizardStore.resetAdditionalStudentLookupResponse();
        wizardStore.validateAndLookupAdditionalStudent();
    });

    watch(() => wizardStore.additionalStudent.mobile, () => {
        if (wizardStore.additionalStudent.errors && wizardStore.additionalStudent.errors.lookup) {
            delete wizardStore.additionalStudent.errors.lookup;
        }
        if (!wizardStore.additionalStudentHasValidFnrAndMobile()) {
            wizardStore.disableManuallyRegisterAdditionalStudent()
            return;
        }
        wizardStore.resetAdditionalStudentLookupResponse();
        wizardStore.validateAndLookupAdditionalStudent();
    });

    const noAdditionalStudentLookupResponse = computed(() => {
        return !wizardStore.additionalStudent.lookupResponse || Object.keys(wizardStore.additionalStudent.lookupResponse).length === 0;
    });

    const registerMoreLabel = computed(() => '<i class="fa fa-plus me-1 tw:mr-1"></i> ' + window.TABS.$t('Registrer ekstra deltaker'));

    function validateAndRegister() {
        wizardStore.validateAndRegisterAdditionalStudent();
    }

    async function continueAndAddIfInfoIsFilled() {
        if (wizardStore.additionalStudentHasValidFnrAndMobile()) {
            await validateAndRegister();
            if (!wizardStore.additionalStudent.errors || Object.keys(wizardStore.additionalStudent.errors).length === 0) {
                wizardStore.completeStep(STEP_ADDITIONAL_ATTENDEES);
            }
        } else {
            wizardStore.completeStep(STEP_ADDITIONAL_ATTENDEES);
        }
    }

    function removeAttender(index) {
        wizardStore.removeAttendee(index);
    }
</script>
